import React, { useState, useEffect } from "react";
import { State } from "../../state/state";
import "../Compendium/Compendium.css";
import "./CompendiumView.css";
import CompendiumItem from "../CompendiumItem/CompendiumItem";
import { IReducer } from "../../state/reducer";
import { BrickInventoryEntry } from "../../state/BrickInventory/BrickInventory";

interface CompendiumViewProps extends IReducer {}

const renderProgress = (state: State) => {
  let found = 0;

  state.bricks.forEach((value, _) => {
    if (value.amount >= 0) found++;
  });

  return found + "/" + (state.bricks.size - 1).toString();
};

const CompendiumView: React.FC<CompendiumViewProps> = ({ state, dispatch }) => {
  const [visibleBricks, setVisibleBricks] = useState<BrickInventoryEntry[]>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [activeSearch, setActiveSearch] = useState<string>("");

  useEffect(() => {
    let filteredBricks: BrickInventoryEntry[] = [];

    state.bricks.forEach((brick, _) => {
      // Hide found
      if (isChecked) {
        if (Number.isNaN(brick.amount)) {
          filteredBricks.push(brick);
        }
      } else {
        filteredBricks.push(brick);
      }
    });

    // Apply search filter if activeSearch is not empty
    if (activeSearch.trim() !== "") {
      filteredBricks = filteredBricks.filter((brick) =>
        brick.name.toLowerCase().includes(activeSearch.toLowerCase()),
      );
    }

    setVisibleBricks(filteredBricks);
  }, [activeSearch, isChecked, state.bricks]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setActiveSearch(event.target.value);
  };

  const handleHideFoundChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setIsChecked(event.target.checked);
  };

  return (
    <div className="compendiumViewWrapper">
      <div className="compendiumViewContainer">
        <div className="compendiumViewHeader">Compendium</div>
        <div className="compendiumViewContent">
          <div className="compendiumContainer">
            <div className="compendiumSearch">
              <div className="compendiumFilters">
                <div className="dropdownSelectContainer">
                  <input
                    type="text"
                    className="searchInput compendiumSearchInput"
                    onChange={handleInputChange}
                    placeholder="Search"
                  />
                </div>
                <input
                  className="compendiumFoundCheckbox"
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleHideFoundChange}
                />
                <span className="hideFound">Hide found</span>
              </div>
              <div className="compendiumProgress">
                Progress: {renderProgress(state)}
              </div>
            </div>
            <div className="compendiumItems">
              {visibleBricks.map((brick, index) => (
                <div key={index}>
                  <CompendiumItem
                    state={state}
                    dispatch={dispatch}
                    id={brick.id}
                    hideFound={isChecked}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompendiumView;
